export const Challenge_Overview_EN = {
  // Challenges overview
  challenges: {
    create_btn: "Create new challenge",
    desc: "Join or create challenges in your favourite games.",
    headline: {
      mine: "My challenges",
      new: "Discover new",
      zone: "Zone activity",
    },
    badges: {
      mine: "Mine",
      new: "Discover new",
      zone: "Zone activity",
    },
    status: {
      ongoing: "Ongoing",
      upcoming: "Upcoming",
      finished: "Finished",
    },
    tooltips: {
      upcoming: "This challenge is starting soon",
      finished: "This challenge is finished",
    },
    games: {
      all: "All games",
    },
  },
};
